import { useAppDispatch } from '@/app/redux/hooks';
import { setContactFormModalOpen } from '@/app/redux/slices/modalsSlice';
import { handleLogout } from '@/common/utils/auth';
import { ArrowUpRightIcon, InfoIcon, SignOutIcon } from '@phosphor-icons/react';
import { Alert } from '@shadcn/components/alert';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@shadcn/components/alert-dialog';
import { Button } from '@shadcn/components/button';

export default function PaymentOverdueModal() {
  const dispatch = useAppDispatch();

  return (
    <AlertDialog open={true}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center justify-between">
            Payment Overdue
            <Button
              variant="outline"
              size="sm"
              className="flex gap-2"
              onClick={handleLogout}
            >
              <SignOutIcon />
              Sign out
            </Button>
          </AlertDialogTitle>
          <AlertDialogDescription>
            There was a problem processing your last payment. Please update your
            payment method immediately to retain access to Spellcaster.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <Alert className="flex items-center gap-2 h-full">
          <InfoIcon size={18} className="ml-1" />
          <div className="flex flex-col gap-2">
            <span>
              To upgrade your payment method, please get in touch with{' '}
              <span
                className="underline cursor-pointer"
                onClick={() => {
                  dispatch(setContactFormModalOpen(true));
                }}
              >
                rupert@spellcaster.education
              </span>
            </span>
          </div>
        </Alert>

        <Button
          className="gap-2"
          onClick={() => {
            dispatch(setContactFormModalOpen(true));
          }}
        >
          Open Contact Form
          <ArrowUpRightIcon size={20} />
        </Button>
      </AlertDialogContent>
    </AlertDialog>
  );
}
